import { render, staticRenderFns } from "./DoctorInfo.vue?vue&type=template&id=a7c4d426"
import script from "./DoctorInfo.vue?vue&type=script&lang=js"
export * from "./DoctorInfo.vue?vue&type=script&lang=js"
import style0 from "./DoctorInfo.vue?vue&type=style&index=0&id=a7c4d426&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports